
var Model = require("../types/Model");

module.exports = Model({
	name: "contactsettings",
	init: init,
	listeners: listeners,

	refresh: refresh,
	pushSettings: pushSettings
});

function init(){
	this.push({});
	this.refresh();
}

function listeners(){
	return {
		"mqtt:$/contact/settings/updated": handle_updated,
		"mqtt:$/contact/settings/removed": handle_removed,
		"connectivity:online": refresh
	};
}

function refresh(){
	return this.api.contacts.settings.list()
		.then(set_contact_settings.bind(this));
}

function set_contact_settings(list){
	var map = makeMap(list);
	this._settings = map;
	this.pushSettings();
}

function handle_updated(setting){
	this._settings[setting._id] = setting.contact_settings;
	this.pushSettings();
}

function handle_removed(data){
	var who = data.who;
	delete this._settings[who];
	this.pushSettings();
}

function pushSettings(){
	var settings = this._settings;
	this.push(settings);
}

function makeMap(contacts){
	return contacts.reduce(function(acc, e){
		acc[e._id] = e.contact_settings;
		return acc;
	}, {});
}